<template>
  <div>
    <div class="szList">
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169034853.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">赵宏强</div>
          <div class="py">Zhao Hongqiang</div>
          <div class="zc">高级职业培训师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169034853.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">赵宏强</div>
              <div class="m2">Zhao Hongqiang</div>
            </div>
          </div>
          <div class="jj">
            简介：深耕职业培训领域超 15
            年，专注于新兴技术类课程，如人工智能基础等教学。曾为多家500强企业定制内训课程。主导开发多套线上线下融合的培训课程体系，在提升学员实践操作能力方面成效显著。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169758602.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">孙健国</div>
          <div class="py">Shun Jianguo</div>
          <div class="zc">高级职业培训师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169758602.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">孙健国</div>
              <div class="m2">Shun Jianguo</div>
            </div>
          </div>
          <div class="jj">
            简介：在职业技能培训方面经验丰富，尤其擅长电气自动化、数控技术等实操性强的课程。拥有自己的技术工作室，常带领学员参与实际项目，为行业发掘和培养了众多优秀技能人才
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169782666.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">李华</div>
          <div class="py">Li Hua</div>
          <div class="zc">高级专业技术培训导师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169782666.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">李华</div>
              <div class="m2">Zhao Hongqiang</div>
            </div>
          </div>
          <div class="jj">
            简介：专注于金融领域的专业技术人员继续教育，擅长讲解金融风险管理、投资分析等课程。曾在知名金融机构任职多年，熟悉行业最新动态与政策法规。，帮助学员提升解决实际金融问题的能力，深受学员好评。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169237864.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">周敏</div>
          <div class="py">Zhou Min</div>
          <div class="zc">中级专业技术培训师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169237864.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">周敏</div>
              <div class="m2">Zhou Min</div>
            </div>
          </div>
          <div class="jj">
            简介：主要负责信息技术类职业培训课程，如编程语言教学、软件测试技术等。教学方法灵活多样，积极参与在线教学平台的建设与优化，为学员提供便捷高效的学习体验。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169268101.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">吴刚</div>
          <div class="py">Wu Gang</div>
          <div class="zc">专业技术教育学科带头人</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169268101.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">吴刚</div>
              <div class="m2">Wu Gang</div>
            </div>
          </div>
          <div class="jj">
            简介：在化工专业技术培训与继续教育领域颇有建树，对化工工艺优化、化工安全管理等课程有着深入研究。将科研成果转化为教学内容，培养学员的创新思维与实践能力，推动化工行业人才培养与技术进步。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169361109.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">郑洁如</div>
          <div class="py">Zheng Jieru</div>
          <div class="zc">优秀专业技术培训讲师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169361109.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">郑洁如</div>
              <div class="m2">Zheng Jieru</div>
            </div>
          </div>
          <div class="jj">
            简介：擅长人力资源管理等专业技术人员继续教育课程。通过角色扮演等互动教学方式，让学员深入理解管理理论与实践技巧。根据企业实际情况提出针对性解决方案，提升企业管理水平。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169384132.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">王强</div>
          <div class="py">Wang Qiang</div>
          <div class="zc">高级职业技术培训专家</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169384132.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">王强</div>
              <div class="m2">Wang Qiang</div>
            </div>
          </div>
          <div class="jj">
            简介：专注于汽车技术领域的职业培训，精通汽车维修技术、新能源汽车技术等课程。拥有丰富的一线维修经验，将实际维修案例带入课堂，使教学内容生动实用。指导学员参加各类汽车技能竞赛，多次获得优异成绩。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169446702.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">冯雪宜</div>
          <div class="py">Feng Xueyi</div>
          <div class="zc">骨干教师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169446702.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">冯雪宜</div>
              <div class="m2">Feng Xueyi</div>
            </div>
          </div>
          <div class="jj">
            简介：在教育技术专业领域，为专业技术人员提供教育信息化等方面的培训。善于运用现代教育技术手段，推动线上教育资源的开发与应用，提升专业技术人员的教育教学能力。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169566524.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">钱悦</div>
          <div class="py">Qian Yue</div>
          <div class="zc">特级专业技术教育讲师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169566524.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">钱悦</div>
              <div class="m2">Qian Yue</div>
            </div>
          </div>
          <div class="jj">
            简介：长期投身于专业技术人员继续教育的工程类课程教学，对建筑工程、机械工程等专业有着深厚见解。参与编写多部行业权威培训教材，培训过的学员在相关职业资格考试中通过率远超平均水平。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169465108.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">陈辉祖</div>
          <div class="py">Chen Huizhu</div>
          <div class="zc">资深专业技术培训顾问</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169465108.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">陈辉祖</div>
              <div class="m2">Chen Huizhu</div>
            </div>
          </div>
          <div class="jj">
            简介：在市场营销、电子商务等领域有着丰富的培训经验，为专业技术人员提供市场分析，  为学员提供前瞻性的行业见解与实用的业务拓展方法，助力学员在市场竞争中脱颖而出。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169585264.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">刘悦</div>
          <div class="py">Liu Yue</div>
          <div class="zc">中级专业技术培训专员</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169585264.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">刘悦</div>
              <div class="m2">Liu Yue</div>
            </div>
          </div>
          <div class="jj">
            简介：负责物流管理、供应链管理等专业技术培训课程。积极参与物流行业调研，将最新行业信息融入教学，帮助学员掌握物流领域前沿知识与技术，提升就业竞争力。
          </div>
        </div>
      </div>
      <div class="szBox">
        <div class="show">
          <div style="text-align: center">
            <img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169637318.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
          </div>
          <div class="name">杨阳</div>
          <div class="py">Yang yang</div>
          <div class="zc">高级职业培训师</div>
        </div>
        <div class="anshow">
          <div style="display: flex; align-items: center">
            <div><img class="userPhoto" src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744169637318.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
            <div class="nms">
              <div class="m1">杨阳</div>
              <div class="m2">Yang yang</div>
            </div>
          </div>
          <div class="jj">
            简介：◦主要从事环保技术等新兴领域教学。注重培养学员的环保意识与创新精神，让学员深入了解环保与新能源技术的应用与发展。积极参与行业学术交流活动，为学员提供最新知识与技术资讯。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.szList {
  width: 1400px;
  display: flex;
  flex-wrap: wrap;
  .szBox {
    cursor: pointer;
    width: 215px;
    height: 240px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    justify-content: center;
    padding-top: 23px;
    margin-right: 22px;
    margin-bottom: 20px;
    .anshow {
      width: 0;
      opacity: 0;
      overflow: hidden;
    }
    .userPhoto {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .name {
      margin-top: 13px;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }
    .py {
      font-weight: 400;
      font-size: 12px;
      color: #c7c7c7;
      text-align: center;
    }
    .zc {
      height: 34px;
      background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
      border-radius: 17px 17px 17px 17px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 34px;
      margin-top: 30px;
      padding: 0 8px;
    }
  }
  .szBox:hover {
    padding: 18px 20px;
    background: linear-gradient(170deg, #95b5ff 0%, #4093f6 100%) !important;
    box-shadow: 0px 5px 40px 0px rgba(65, 147, 246, 0.1) !important;
    .userPhoto {
      width: 48px !important;
      height: 48px !important;
      border-radius: 50%;
    }
    .anshow {
      overflow: auto !important;
      opacity: 1 !important;
      width: 100% !important;
    }
    .show {
      opacity: 0 !important;
      width: 0 !important;
    }
    .nms {
      margin-left: 10px;
      .m1 {
        width: 60px;
        height: 22px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
      }
      .m2 {
        height: 16px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        line-height: 14px;
        text-align: center;
      }
    }
    .jj {
      margin-top: 15px;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
    }
  }
  .szBox:nth-child(6n) {
    margin-right: 0 !important;
  }
}
</style>
